var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#001EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8049 9.35739C21.707 9.35739 23.5313 10.1573 24.876 11.5815C26.2209 13.0056 26.9766 14.937 26.9766 16.9509C26.9766 21.1449 19.8047 33.6424 19.8047 33.6424C19.8047 33.6424 12.6328 21.1449 12.6328 16.9509C12.6328 14.937 13.3884 13.0056 14.7334 11.5815C16.0783 10.1573 17.9026 9.35739 19.8045 9.35739H19.8049ZM19.8049 21.3212V21.321C20.8996 21.321 21.9494 20.8606 22.7233 20.0412C23.4973 19.2217 23.9323 18.1102 23.9323 16.951C23.9323 15.7921 23.4974 14.6806 22.7233 13.8611C21.9494 13.0415 20.8996 12.5811 19.8049 12.5811C18.7103 12.5811 17.6605 13.0415 16.8866 13.8611C16.1125 14.6806 15.6777 15.7921 15.6777 16.951C15.6777 18.1101 16.1123 19.2217 16.8865 20.0414C17.6606 20.8608 18.7104 21.3212 19.8049 21.321L19.8049 21.3212Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegion);
export default __webpack_public_path__ + "static/media/region.8aa108f3991a26340b28f8427bf4da22.svg";
export { ForwardRef as ReactComponent };